import React from "react";
import { withRouter, NavLink } from "react-router-dom";
import classes from "./Footer.css";
import global from "../../global.css";
import logo from "../../assets/LogoWhite.png";
import paxrights from "../../assets/paxrights.png";
import cao from "../../assets/cao.png";

const Footer = props => {
  return (
    <div className={[classes.Footer, global.ClassGradiant].join(" ")}>
      <div className={global.Responsive}>
        <div className={classes.ThreeBox}>
          <img className={classes.logoFooter} src={logo} alt="لوگو شرکت" />
          <p>
            جزيره کيش- بلوار ايران -روبه روي آتشنشاني - قطعه EX52 - طبقه سوم -
            واحد 16 <br />
            کدپستي: 941714456
          </p>
          <p>
            <span>دفتر تهران : </span> <span dir="ltr">021 41578</span>
          </p>
          <p>
            <span> تلفن تماس : </span> <span dir="ltr">076 44421969</span>
          </p>
        </div>
        <div className={classes.ThreeBox} style={{ textAlign: "center" }}>
          <img
            onClick={() => {
              window.open(
                "http://www.cao.ir/paxrights",
                "Popup",
                "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30"
              );
            }}
            className={classes.passengerRight}
            src={paxrights}
            alt="سامانه ي حقوق مسافر"
            title="حقوق مسافر"
          />
          <img
            onClick={() => {
              window.open(
                "http://www.cao.ir",
                "Popup",
                "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30"
              );
            }}
            className={classes.passengerRight}
            src={cao}
            alt="سازمان هواپيمايي کشوري"
            title="سازمان هواپيمايي کشوري"
          />
        </div>
        <div className={classes.ThreeBox}>
          <div className={classes.ul}>
            <h3>اطلاعات</h3>
            <ul>
              <li onClick={() => window.scrollTo(0, 0)}>
                <NavLink to="/PassengerRight"> حریم خصوصی </NavLink>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <NavLink to="/LawPage">قوانین و مقررات </NavLink>
              </li>
            </ul>
          </div>
          <div className={classes.ul}>
            <h3>دسترسی سریع</h3>
            <ul>
              <li onClick={() => window.scrollTo(0, 0)}>
                <NavLink to="/Contact">تماس با ما</NavLink>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <NavLink to="/">استرداد انلاین </NavLink>
              </li>
              <li onClick={() => window.scrollTo(0, 0)}>
                <NavLink to="/sign">درخواست Sign</NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className={classes.signing}>
        <p>
          تمامی حقوق مادی و معنوی این وبسایت متعلق به شرکت محراب سیر کیش است .
          1397
        </p>
      </div>
    </div>
  );
};

export default withRouter(Footer);
